export const CART_TYPE = "modal" || "drawer";

export const ANIMATION_LOAD = "false" === "true";
export const ANIMATION_INTERVAL =
  "default" === "default" ? 0 : 0.05;
// fade_up, fade_down, fade_in
export const ANIMATION_INTERVAL_STYLE =
  "fade_in" || "fade_up";
